import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import type { InterventionCenterGovStatistics } from '../../../common/types/statistics/fhbfStatistics';

type Props = {
  statistics: InterventionCenterGovStatistics;
};

function ReasonForTheConsultation({ statistics }: Props) {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'block',
        padding: '0px 24px 20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
      }}
    >
      <Grid container rowSpacing={2}>
        <Grid item xs={12}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            4 Anlass der Beratungs<u>fälle</u>
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>
            Häusliche Gewalt (körperliche Gewalt, psychische Gewalt, sexualisierte Gewalt)
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem' align='right' border='2px solid black' px='5px' py='5px'>
            {statistics.numberOfDomesticViolence}
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Stalking durch (Ex-)Partner</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem' align='right' border='2px solid black' px='5px'>
            {statistics.numberOfExPartnerStalking}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ReasonForTheConsultation;
